import { Button, ButtonProps as MuiButtonProps } from '@mui/material';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { COLORS } from '$gbusiness/enums';
import { SPACE } from '$gstyles';

interface ButtonProps {
  children: React.ReactNode;
  color?: MuiButtonProps['color'];
  icon?: any;
  endIcon?: any;
  fullWidth?: boolean;
  onClick: (e) => void;
  size?: MuiButtonProps['size'];
  variant?: MuiButtonProps['variant'];
  disabled?: MuiButtonProps['disabled'];
  isLoading?: boolean;
  loadingText?: string;
  testId?: string;
  [x: string]: any;
}

const Component: React.FC<ButtonProps> = ({
  children,
  color = COLORS.PRIMARY,
  fullWidth = false,
  onClick,
  icon,
  endIcon,
  disabled,
  size = 'large',
  variant = 'contained',
  isLoading,
  testId = '',
  loadingText = false,
  ...rest
}) => {
  const shouldDisable = isLoading || disabled ? true : false;

  let testIdValue = testId || undefined;
  if (!testIdValue && typeof children === 'string') {
    testIdValue = `button.${children || variant}`;
  }
  return (
    <Button
      color={color}
      fullWidth={fullWidth}
      disabled={shouldDisable}
      size={size}
      data-testid={testIdValue}
      startIcon={icon}
      endIcon={endIcon}
      variant={variant}
      {...rest}
      onClick={onClick}>
      {loadingText && isLoading ? loadingText : children}
      {isLoading && <CircularProgress size={16} style={{ marginLeft: SPACE.MEDIUM }} />}
    </Button>
  );
};

export default Component;
